import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import StarredContentMenuQuery, {
	type StarredContentMenuQuery$data,
	type StarredContentMenuQuery$variables,
} from './__generated__/StarredContentMenuQuery.graphql';
import { starredContentMenuQueryVars } from './StarredContentMenu';

export function preloadStarredContentMenu() {
	return query<StarredContentMenuQuery$data, StarredContentMenuQuery$variables>({
		query: StarredContentMenuQuery,
		variables: starredContentMenuQueryVars,
		fetchPolicy: 'network-only',
	});
}
